import * as React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Button, Typography } from "@mui/material";
import EventsTab from "../../adminComponents/EventsTab";
import ArtistsTab from "../../adminComponents/ArtistsTab";
import ContactForm from "../../adminComponents/Contact";
import AboutUsTab from "../../adminComponents/AboutUsTab";
import SoundCloudTab from "../../adminComponents/SoundCloudTab";
import styles from "./styles";
import { useAuthContext } from "../../context/authContext";
import authApi from "../../api/authApi";

const AdminPanel = () => {
  const [value, setValue] = React.useState("1");
  const { removeUser } = useAuthContext();

  const handleChange = (_event, newValue) => {
    setValue(newValue);
  };

  const handleLogout = async () => {
    try {
      await authApi.post("/auth/logout");
    } catch {
      // proceed with local logout regardless
    }
    localStorage.removeItem("authToken");
    removeUser();
  };

  return (
    <Box sx={styles.pageWrapperSx}>
      {/* Admin header */}
      <Box sx={styles.headerSx}>
        <Typography variant="overline" sx={styles.headerLabelSx}>
          Admin Panel
        </Typography>
        <Button size="small" onClick={handleLogout} sx={styles.logoutButtonSx}>
          Logout
        </Button>
      </Box>

      <TabContext value={value}>
        {/* Sticky tab nav */}
        <Box sx={styles.tabBarSx}>
          <TabList
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            sx={styles.tabListSx}
          >
            <Tab label="Events" value="1" />
            <Tab label="Artists" value="2" />
            <Tab label="About Us" value="3" />
            <Tab label="Contact" value="4" />
            <Tab label="SoundCloud" value="5" />
          </TabList>
        </Box>

        {/* Tab content */}
        <Box sx={styles.tabContentSx}>
          <TabPanel value="1" sx={styles.tabPanelSx}>
            <EventsTab />
          </TabPanel>
          <TabPanel value="2" sx={styles.tabPanelSx}>
            <ArtistsTab />
          </TabPanel>
          <TabPanel value="3" sx={styles.tabPanelSx}>
            <AboutUsTab />
          </TabPanel>
          <TabPanel value="4" sx={styles.tabPanelSx}>
            <ContactForm />
          </TabPanel>
          <TabPanel value="5" sx={styles.tabPanelSx}>
            <SoundCloudTab />
          </TabPanel>
        </Box>
      </TabContext>
    </Box>
  );
};

export default AdminPanel;
